<template>
  <v-app-bar app color='#fff' class='top-navigation'>
        <div class="logo">
          <a href="/">
            <img src="@/assets/img/logo.png">
          </a>
        </div>
        
        <div class="search">
          <v-icon class='icon'>fas fa-search</v-icon>
          <input type="text" v-model='searchString' placeholder="I'm searching for">
        </div>
        <div class="user">

          <div class="avatar">
            <v-menu
              bottom
              min-width="170px"
              rounded
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  x-large
                  v-on="on"
                  style='float: right;'
                >
                  <v-avatar
                    color="#4c84ff"
                    size="36"
                  >
                    <span class="white--text" style="font-size: 18px" v-if='user'>{{(user.email).substring(0,2)}}</span>
                  </v-avatar>
                </v-btn>
              </template>
              <v-card>
                <v-list-item-content class="justify-center">
                  <div class="mx-auto text-center">
                    <v-btn
                      depressed
                      rounded
                      text
                      @click='logout'
                    >
                      Log out
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-card>
            </v-menu>
          </div>

          <div class="contributors">

            <div class="invite-btn" @click="inviteActive=true">
              Invite

              <div class="invite-section" v-show='inviteActive'>
                <div class="invite-input">
                  <div class="invite-title">
                    Invite Users
                  </div>
                  <input type="text" v-model='searchStringUser' @keyup="findUser()">
                </div>
                <div class="searched-users-section">
                  <div v-if="searchedUsers && invUser.email != user.email" v-for="invUser in searchedUsers" class="su-li" @click="searchStringUser=invUser.email;selectedUser=invUser;searchedUsers=null">
                    {{invUser.name}} 
                  </div>
                </div>

                <div class="invite-user-btn" @click="inviteUser()">
                  Send Invite
                </div>
              </div>
            </div>

            <div class="invite-shade" v-show='inviteActive' @click="inviteActive=false"></div>

            <div class="contributor">
              <v-icon class='icon'>fas fa-comments</v-icon>
            </div>
            <div class="contributor">
              <v-icon class='icon' @click="notificationsActive=!notificationsActive">fas fa-bell</v-icon>
              <div v-if='notifications' class="notifications-counter">
                {{notifications.length}}
              </div>
              <div class="notifications-section" v-show='notificationsActive'>
                <div v-if='notifications' v-for='notification in notifications' class="notification-li">
                  Test Team has invited you to join!
                  Accept invitation here <span @click="acceptInvite(notification.team_id)">Join</span>
                </div>
              </div>
            </div>
            

            <div class="team-members-section" v-if='teamMembers' style="margin-right: 10px;" :key='changeTeamState'>
              <div v-for="owner in teamMembers.owner" class="contributor custom-contributor" style="margin-right: 8px;">
                <v-avatar
                  color="#643fff"
                  size="36"
                  :style="{'background': randColor()}"
                >
                  <span class="white--text" style="font-size: 18px;text-transform: uppercase;">{{owner.name.substring(0,2)}}</span>
                </v-avatar>
              </div>
              <div v-for="member in teamMembers.members" class="contributor custom-contributor" style="margin-right: 8px;">
                <v-avatar
                  color="#643fff"
                  size="36"
                  :style="{'background': randColor()}"
                >
                  <span class="white--text" style="font-size: 18px;text-transform: uppercase;">{{member.name.substring(0,2)}}</span>
                </v-avatar>
              </div>
            </div>
            
          </div>

        </div>
  </v-app-bar>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex'
  import api from '@/api'

	export default {

    data () {
      return {
        user: null,
        searchString: '',
        searchStringUser: '',
        searchedUsers: null,
        selectedUser: null,
        inviteActive: false,
        notifications: null,
        notificationsActive: false,
        teamMembers: null,
        colors: ['#f4a261', '#2a9d8f', '#e76f51', '#264653', '#e9c46a'],
        color: '#f4a261',
      }
    },

		computed: {
      changeTeamState () {
        this.getTeamMembers()
        return this.$store.state.changeTeamState
      }
    },

    methods: {

      async getLogedInUser () {
        const response = await api.auth.me()
        if (response.status < 300) {

          this.user = response.data
          this.$store.commit('setUser', response.data)
        } else {
          localStorage.logged = false
        }
      },

      async findUser () {
        if (this.searchStringUser.length > 2) {
          const response = await api.users.findUser(this.searchStringUser)
          if (response.status < 300) {
            this.searchedUsers = response.data
          } else {
            
          }
        }
      },

      async inviteUser () {
        const response = await api.users.inviteUser(this.selectedUser.id)
        if (response.status < 300) {
          this.searchStringUser = ''
          this.searchedUsers = null
          this.selectedUser = null
          this.inviteActive = false
          console.log('invited user', response)
        } else {
          this.searchStringUser = ''
          this.searchedUsers = null
          this.selectedUser = null
          this.inviteActive = false
          console.log('invited error')
        }
      },

      async getUserNotifications () {
          const response = await api.users.getNotifications()
          if (response.status < 300) {
            this.notifications = response.data
            console.log('user notifications', response.data)
          } else {
            
          }
      },

      async acceptInvite (teamId) {
        const response = await api.users.acceptTeamInvite(teamId)
        if (response.status < 300) {
          console.log('accept invite', response)
        } else {
          console.log('invited error')
        }
      }, 

      async getTeamMembers () {
        const response = await api.users.getTeamMembers()
        if (response.status < 300) {
          console.log('team members', response)
          this.teamMembers = response.data
        } else {
          console.log('invited error')
        }
      },

      async logout () {
        // const response = await axios.post('api/auth/logout')
        const response = await api.auth.logOut()
        if (response.status < 300) {
          localStorage.logged = false
          setTimeout(function() {
            window.location.href = '/login'
          }, 300)
        } else {
          console.log('LOGOUT!', response)
        }
      },

      randColor () {
        return this.colors[Math.floor(Math.random() * this.colors.length)]
      },
    },

    mounted () {
      this.getLogedInUser()
      this.getUserNotifications()
      this.getTeamMembers()
    }

	}

</script>

<style lang="scss" scoped>
  
  .top-navigation {
    padding: 0 5% 0 5%;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.01), 0px 4px 5px 0px rgba(0, 0, 0, 0.01), 0px 1px 20px 0px rgba(0, 0, 0, 0.01) !important;

    .logo {
      width: 240px;
      height: 100%;
      line-height: 75px;
      border-right: 1px solid #eee;
      padding-right: 45px;

      img {
        width: 100%;
      }
    }

    .search {
      width: 50%;
      padding-left: 45px;

      .icon {
        font-size: 17px;
        color: #a0aabd;
      }

      input {
        padding-left: 15px;
        font-size: 14px;
        font-weight: 300;
        border: 0;
        outline: 0;
        color: #a0aabd;
      }

      ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #a0aabd;
      }

      :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #a0aabd;
      }

      ::-ms-input-placeholder { /* Microsoft Edge */
        color: #a0aabd;
      }
    }

    .user {
      float: right;
      height: 65px;
      width: 30%;

      .avatar {
        float: right;
        margin-top: 7px;
        padding-left: 10px;
        line-height: 65px;
        border-left: 1px solid #eee;
      }

      .contributors {
        float: right;
        padding-right: 15px;
        line-height: 65px;

        .notifications-counter {
          position: absolute;
          width: 15px;
          height: 15px;
          margin-top: -48px;
          margin-left: 18px;
          font-size: 10px;
          font-weight: 600;
          text-align: center;
          line-height: 16px;
          border-radius: 50%;
          background: red;
          color: #fff;
        }

        .notifications-section {
          position: absolute;
          width: 220px;
          margin-top: -10px;
          margin-left: -190px;
          padding: 15px;
          padding-top: 5px;
          padding-bottom: 5px;
          border-radius: 4px;
          box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.10), 0 3px 10px 0 rgba(0, 0, 0, 0.05);
          background: #fff;

          .notification-li {
            font-size: 12px;
            padding-top: 5px;
            padding-bottom: 5px;
            line-height: 20px;

            span {
              margin-left: 3px;
              padding: 5px;
              border-radius: 4px;
              background: #4C84FF;
              color: #fff;
              cursor: pointer;
              transition: all 0.25s;

              &:hover {
                opacity: 0.7;
              }
            }
          }
        }

        .invite-shade {
          position: fixed;
          width: 100%;
          height: 100vh;
          top: 65px;
          left: 0;
          background: rgba(180,180,180,0.45);
          z-index: 9;
        }

        .invite-btn {
          float: right;
          width: 60px;
          height: 35px;
          margin-top: 17px;
          margin-left: 15px;
          font-size: 14px;
          line-height: 35px;
          text-align: center;
          border-radius: 4px;
          background: #4C84FF;
          color: #fff;
          cursor: pointer;
          transition: all 0.25s;

          .invite-section {
            position: relative;
            width: 250px;
            margin-top: 2px;
            margin-left: -190px;
            padding: 15px;
            border-radius: 4px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05), 0 3px 10px 0 rgba(0, 0, 0, 0.05);
            background: #fff;
            z-index: 9999999;

            .searched-users-section {
              width: 100%;
              margin-top: 10px;
              text-align: left;
              color: #757575;
              overflow: hidden;

              .su-li {
                line-height: 25px;
                margin-top: 3px;
                margin-bottom: 3px;
              }
            }

            .invite-input {

              input {
                width: 100%;
                padding-left: 8px;
                border: 1px solid #dedede;
                border-radius: 4px;
                outline: none;
              }

              .invite-title {
                margin-bottom: -5px;
                font-weight: 500;
                text-align: left;
                color: #757575;
              }
            }

            .invite-user-btn {
              width: 100px;
              height: 35px;
              margin-top: 10px;
              margin-left: calc(50% - 50px);
              font-size: 14px;
              line-height: 35px;
              text-align: center;
              border-radius: 4px;
              background: #4C84FF;
              color: #fff;
              cursor: pointer;
              transition: all 0.25s;
            }
          }
        }

        .team-members-section {
          float: right;
        }

        .contributor {
          float: right;
          margin-left: 3px;

          .icon {
            font-size: 18px;
            margin-left: 10px;
            cursor: pointer;
            color: #9fa9bc;
            transition: all 0.25s;

            &:hover {
              opacity: 0.7;
            }
          }
        }

        .custom-contributor {
          width: 30px;
          margin: 0;
        }
      }
    }
  }

</style>